import { render } from "./CreateBackupSchedule.vue?vue&type=template&id=e38360da&scoped=true"
import script from "./CreateBackupSchedule.vue?vue&type=script&lang=js"
export * from "./CreateBackupSchedule.vue?vue&type=script&lang=js"

import "./CreateBackupSchedule.vue?vue&type=style&index=0&id=e38360da&lang=less&scoped=true"

import exportComponent from "/opt/novus-cloud-ui/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e38360da"]])

export default __exports__